import { HockeyGameLogTypes } from '../models/hockey-game-log';
import { Locales } from './locales';

export const HockeyGameLogTypeLocalization = {
  [Locales.ru]: {
    [HockeyGameLogTypes.enter_game]: 'Выход на площадку',
    [HockeyGameLogTypes.exit_game]: 'Ушел с площадки',
    [HockeyGameLogTypes.shot_miss]: 'Бросок мимо',
    [HockeyGameLogTypes.shot_on_goal]: 'Бросок по воротам',
    [HockeyGameLogTypes.shot_blocked]: 'Заблокированный бросок',
    [HockeyGameLogTypes.goal]: 'Гол',
    [HockeyGameLogTypes.shootout_attempt]: 'Буллит промах',
    [HockeyGameLogTypes.shootout_goal]: 'Буллит гол',
    [HockeyGameLogTypes.after_game_shootout_attempt]: 'Буллит промах',
    [HockeyGameLogTypes.after_game_shootout_goal]: 'Буллит гол',
    [HockeyGameLogTypes.assist]: 'Передача',
    [HockeyGameLogTypes.block_shot]: 'Блокировка броска',
    [HockeyGameLogTypes.minor_penalty]: 'Малый штраф',
    [HockeyGameLogTypes.major_penalty]: 'Большой штраф',
    [HockeyGameLogTypes.misconduct_penalty]: 'Дисциплинарный штраф',
    [HockeyGameLogTypes.game_misconduct_penalty]: 'Дисциплинарный штраф до конца игры',
    [HockeyGameLogTypes.match_penalty]: 'Матч-штраф',
    [HockeyGameLogTypes.penalty_shot]: 'Штрафной бросок',
    [HockeyGameLogTypes.face_off_lose]: 'Проигрыш в вбрасывании',
    [HockeyGameLogTypes.face_off_win]: 'Победа в вбрасывании',
    [HockeyGameLogTypes.save]: 'Отражен бросок',
    [HockeyGameLogTypes.shootout_save]: 'Отражен бросок',
    [HockeyGameLogTypes.after_game_shootout_save]: 'Отражен бросок',
    [HockeyGameLogTypes.timeout]: 'Таймаут',
    [HockeyGameLogTypes.penalty_start]: 'Начало штрафного времени',
    [HockeyGameLogTypes.penalty_end]: 'Конец штрафного времени',
    [HockeyGameLogTypes.steal]: 'Отбор',
    [HockeyGameLogTypes.loss]: 'Потеря',
    [HockeyGameLogTypes.sharp_pass]: 'Острая передача',
  },
  [Locales.en]: {
    [HockeyGameLogTypes.enter_game]: 'Entering the court',
    [HockeyGameLogTypes.exit_game]: 'Exit the court',
    [HockeyGameLogTypes.shot_miss]: 'Missing shot',
    [HockeyGameLogTypes.shot_on_goal]: 'Shot on a goal',
    [HockeyGameLogTypes.shot_blocked]: 'Blocked shot',
    [HockeyGameLogTypes.goal]: 'Goal',
    [HockeyGameLogTypes.shootout_attempt]: 'Shootout miss',
    [HockeyGameLogTypes.shootout_goal]: 'Shootout goal',
    [HockeyGameLogTypes.after_game_shootout_attempt]: 'Shootout miss',
    [HockeyGameLogTypes.after_game_shootout_goal]: 'Shootout goal',
    [HockeyGameLogTypes.assist]: 'Assist',
    [HockeyGameLogTypes.block_shot]: 'Shot is blocked',
    [HockeyGameLogTypes.minor_penalty]: 'Minor penalty',
    [HockeyGameLogTypes.major_penalty]: 'Major penalty',
    [HockeyGameLogTypes.misconduct_penalty]: 'Misconduct penalty',
    [HockeyGameLogTypes.game_misconduct_penalty]: 'Disciplinary penalty until the end of the game',
    [HockeyGameLogTypes.match_penalty]: 'Match penalty',
    [HockeyGameLogTypes.penalty_shot]: 'Penalty shot',
    [HockeyGameLogTypes.face_off_lose]: 'Face-off lose',
    [HockeyGameLogTypes.face_off_win]: 'Face-off win',
    [HockeyGameLogTypes.save]: 'Throw is reflected',
    [HockeyGameLogTypes.shootout_save]: 'Throw is reflected',
    [HockeyGameLogTypes.after_game_shootout_save]: 'Throw is reflected',
    [HockeyGameLogTypes.timeout]: 'Timeout',
    [HockeyGameLogTypes.penalty_start]: 'The beginning of the penalty time',
    [HockeyGameLogTypes.penalty_end]: 'End of penalty time',
    [HockeyGameLogTypes.steal]: 'Steal',
    [HockeyGameLogTypes.loss]: 'Loss',
    [HockeyGameLogTypes.sharp_pass]: 'Sharp pass',
  }
};
